import { DashboardModule, Form } from '@domain-group/suit-theme'

import { UseFormPayload } from '@domain-group/react-hooks'

import SettingItem from '../SettingItem'

interface ArtworkSettingsProps {
  formPayload : UseFormPayload,
}

const ArtworkSettings = (props: ArtworkSettingsProps) => {
  const { formPayload } = props
  const {
    entityState: {
      options: {
        require_artwork_data_sync,
      },
    },
    handlers,
  } = formPayload

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Artworks">
      <SettingItem
        isChecked={require_artwork_data_sync}
        title="Artwork Data Sync"
        secondaryText="Artwork requires data sync for order approval"
      >
        <Form.Field>
          {/*
           // @ts-expect-error TS2322 */}
          <select
            data-value-type="boolean"
            name="options.require_artwork_data_sync"
            value={require_artwork_data_sync}
            {...handlers}
          >
            <option value="false">Not Required</option>
            <option value="true">Required (Default)</option>
          </select>
        </Form.Field>
      </SettingItem>
    </DashboardModule>
  )
}

export default ArtworkSettings
